// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/settings-2.js';

import { paths } from '../generated/settings-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('settings-2', Original, paths);
